import { Megaphone } from 'lucide-react'
import type { AvisoContent } from '../services/api'

export function AvisoBanner({ aviso }: { aviso: AvisoContent }) {
  if (!aviso.enabled) return null

  return (
    <div className="bg-[#f1b90f] border-b-4 border-[#0b2e46] shadow-lg" role="status">
      <div className="container py-5">
        <div className="flex items-start gap-4">
          <div className="mt-0.5 shrink-0 w-11 h-11 rounded-full bg-[#0b2e46] flex items-center justify-center ring-4 ring-[#0b2e46]/20 animate-pulse">
            <Megaphone size={22} className="text-[#f1b90f]" />
          </div>
          <div>
            <p className="text-sm font-extrabold uppercase tracking-wider text-[#0b2e46]">{aviso.title}</p>
            <p className="text-base text-[#0b2e46] font-medium leading-relaxed mt-1.5 max-w-4xl">{aviso.message}</p>
            {aviso.publishNote && (
              <p className="text-xs text-[#0b2e46]/80 mt-2 italic">{aviso.publishNote}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
